// plugins/recaptcha.js
import VueVirtualScroller from 'vue-virtual-scroller'
// The plugin enables the usage of Google reCAPTCHA in a Nuxt.js application
// by registering the VueReCaptcha plugin with the necessary configuration options.
export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.use(VueVirtualScroller)
})
